/**
 * Provides a way to validate that a mesh meets the components to be loaded into the MMD runtime
 */
export var MmdMesh;
(function (MmdMesh) {
    /**
     * Check if the mesh is MMD model root mesh
     */
    function isMmdMesh(mesh) {
        if (mesh.metadata === null || !mesh.metadata.isMmdModel)
            return false;
        return true;
    }
    MmdMesh.isMmdMesh = isMmdMesh;
    /**
     * Check if the mesh is MMD model root mesh and can create `MmdModel` instance
     * @param mesh Mesh to check
     * @returns `true` if the mesh is `MmdSkinnedMesh`
     */
    function isMmdSkinnedMesh(mesh) {
        if (mesh.metadata === null || !mesh.metadata.isMmdModel)
            return false;
        if (mesh.metadata.skeleton === null)
            return false;
        return true;
    }
    MmdMesh.isMmdSkinnedMesh = isMmdSkinnedMesh;
})(MmdMesh || (MmdMesh = {}));
